<div id="wrapper" *ngIf="this.screenView">
  <div>
    <app-menu [tabActive]="this.tabActive" [showUserMobile]="this.global.showUserMobile" class="no-print"></app-menu>
  </div>
  <div>
    <!-- <app-tab-nav></app-tab-nav> -->
  </div>
  <div class="print-zone hidden">
    <div class="print-img">
      <img class="img-print" src="../../assets/images/miclaro-logo.png" alt="">
    </div>
  </div>
  <div class="allcont logsize m-top-i">
    <div class="basicrow ">
      <div class="container">
        <div class="basicr-line-i no-print">
          <div class="fulltitle  f-btitle autodef">
            <span><img width="100%" class="icon-iptv-2" src="/assets/images/icon_IPTV2.png"></span> <a
              class="ClaroTv">Claro</a><a class="tvmas">tv+</a>
          </div>
        </div>
        <!-- escribir desde aqui -->
        <div class="basicr-line-i m-top-i no-print">
          <div class="autodef ">
            Confirmación
          </div>
        </div>
        <div class="center-iptv">
          <div class="general-iptv">
            <div class=" m-top-i basicr-line-i print-zone ">
              <div class="order-box">
                <div class="order-container">
                  <div class="img-box">
                    <img src="assets/images/icon_confirmacion.png">
                  </div>
                  <div>
                    <span class="box-title">¡Tu orden fue procesada con éxito!</span>
                    <span class="box-subtitle">
                      recibiras un correo electronico con los pasos para el Setup del servicio <a
                        class="ClaroTv">Claro</a><a class="tvmas">tv+</a> en todos tus
                      dispositivos.
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="m-top-i basicr-line-i border-none no-print">
              Guarda o imprime la siguiente información como evidencia de la transacción:
            </div>
            <div class="basicr-line-i">
              <div class="information-box print-zone">
                <div class="information-internal">
                  <div class="zone1">
                    <span class="zone1-title"> Monto</span>
                    <span class="zone1-amount"> {{ this.totalAmount | currency}} </span>
                  </div>
                  <div class="zone2">
                    <div class="left-zone">
                      <div class="mont-plan">
                        <span> Resumen De Orden </span>
                      </div>
                      <ul>
                        <li>
                          Número de Orden
                          <span class="mobile">{{this.itemsOrder.order}}</span>
                        </li>
                        <!-- <li>
                          Número de Transacción
                          <span class="mobile">&nbsp;</span>
                        </li> -->
                        <li>
                          Número de Autorización
                          <span class="mobile">{{this.itemsOrder.paymentInfo.autorization}}</span>
                        </li>
                        <li>
                          Medio de pago
                          <span class="mobile">{{this.typeCard}}</span>
                        </li>
                        <li>
                          Número de tarjeta
                          <span class="mobile">{{this.itemsOrder.paymentInfo.cartNum}}</span>
                        </li>
                        <li>
                          Fecha y Hora
                          <span class="mobile">{{this.itemsOrder.createdDate}}</span>
                        </li>
                        <li>
                          Dirección de Envío
                          <span class="mobile">{{this.itemsOrder.address}}</span>
                        </li>
                      </ul>
                    </div>
                    <div class="right-zone">
                      <div class="mont-plan">
                        <span> <br /> </span>
                      </div>
                      <dl class="text-black">
                        <dd> &nbsp; {{this.itemsOrder.order}}</dd>
                        <!-- <dd> &nbsp; </dd> -->
                        <dd> &nbsp; {{this.itemsOrder.paymentInfo.autorization}}</dd>
                        <dd> &nbsp; {{this.typeCard}}</dd>
                        <dd> &nbsp; {{this.itemsOrder.paymentInfo.cartNum}}</dd>
                        <dd> &nbsp; {{this.itemsOrder.createdDate}}</dd>
                        <dd> &nbsp; {{this.itemsOrder.address}}</dd>
                      </dl>
                    </div>
                    <div class="left-zone">
                      <div class="mont-plan">
                        <span> Plan Mensual </span>
                      </div>
                      <ul>
                        <li>
                          Plan Claro {{this.dataPlan.catalogName}}:
                          <span matTooltip={{this.dataPlan.productName}}>
                            <span class="web">{{this.dataPlan.productName}}</span>
                            <span class="mobile">{{this.dataPlan.productName}}</span>
                          </span>
                          <div class="red-text mobile">{{this.dataPlan.payPrice | currency}}</div>
                        </li>
                        <li>
                          Oferta:
                          <span matTooltip={{this.nameOffer}}>
                            <span class="web">{{this.nameOffer}}</span>
                            <span class="mobile">{{this.nameOffer}}</span>
                          </span>
                        </li>
                        <li *ngIf="this.nameSva.length>0">
                          Add Ons:
                          <span matTooltip={{this.nameSva}}>
                            <span class="web">{{this.nameSva}}</span>
                            <span class="mobile">{{this.nameSva}}</span>
                          </span>
                          <div class="red-text mobile">{{ this.amountSva | currency }}</div>
                        </li>
                        <li *ngIf="this.nameStreaming.length>0">
                          Streaming:
                          <span matTooltip={{this.nameStreaming}}>
                            <span class="web">{{this.nameStreaming}}</span>
                            <span class="mobile">{{this.nameStreaming}}</span>
                          </span>
                          <div class="mobile">
                            <div *ngIf="this.installments > 0">
                              <div class="red-text" *ngIf="this.amountStreaming>0">
                                {{this.amountStreaming | currency}}
                              </div>
                              <div class="red-text" *ngIf="this.amountStreaming==0">
                                Gratis!
                              </div>
                            </div>
                          </div>
                          <span class="mobile">Pago en {{this.installments}} meses</span>
                        </li>
                        <li>Cantidad de dispositivos: {{this.numberOfDevices}}</li>
                        <li *ngIf="this.hasContract==true">
                          <span>Con contrato a {{this.contractMonths}} meses </span>
                        </li>
                        <li>
                          <span>Pago Mensual</span>
                          <div class="red-text mobile">{{ this.totalAmount | currency}}</div>
                        </li>
                      </ul>
                    </div>
                    <div class="right-zone">
                      <div class="mont-plan">
                        <span> <br /> </span>
                      </div>
                      <dl class="text-black">
                        <dd class="red-text">{{this.dataPlan.payPrice | currency}}</dd>
                        <span class="no-display" *ngIf="this.nameOffer!=''">{{this.nameOffer}}</span>
                        <span class="no-display" *ngIf="this.nameOffer==''">Pago mensual</span>
                        <dd *ngIf="this.nameSva.length>0">
                          <span class="no-display">
                            {{this.nameSva}}
                          </span>
                          {{ this.amountSva | currency }}
                        </dd>
                        <dd *ngIf="this.nameStreaming.length>0">
                          <span *ngIf="this.installments > 0">
                            <span *ngIf="this.amountStreaming>0">
                              {{this.amountStreaming | currency}}
                            </span>
                            <span *ngIf="this.amountStreaming==0">
                              Gratis!
                            </span>
                          </span>
                        </dd>
                        <dd>&nbsp;</dd>
                        <dd class="red-text">{{ this.totalAmount | currency}}</dd>
                        <dd class="red-text">Pago mensual a {{this.installments}} meses de plazo</dd>
                      </dl>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="no-print">
              <button class="btmMaterial3 btmAlert on left-zone-btn" (click)="goToHome();">
                Cerrar
              </button>
              <button class="btmMaterial3 btmAlert on right-zone-btn" (click)="print();">
                Imprimir
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer class="no-print"></app-footer>
</div>
